export const CHAT = 'Chat';
export const SAVE_MESSAGES = 'SaveMessage';
export const RETRIEVE_MESSAGES = 'RetrieveMessages';
export const LOADING = 'Loading';
export const GET_SPEECH_TOKEN = 'test';
export const KEY_BY_ASPNETCOMPANYID_EMPLOYEEID =
	'KeyByAspNetCompaniesIdEmployeeId';
